import { FC } from "react";
import NotificationPopup from "../../NotificationPopup/NotificationPopup";

interface iProps {
    isOpen: boolean;
}

const CopyNotification:FC<iProps> = ({ isOpen, children }) => {
    return (
        <NotificationPopup
            isOpened={isOpen}
            hasCloseButton={false}
            style={CopyNotificationStyles}
            className="notification-popup--table"
        >
            {children ?? CopyNotificationContent}
        </NotificationPopup>
    );
};
const CopyNotificationContent = <span>Table successfully copied</span>;
const CopyNotificationStyles = { width: "auto", height: "auto" };
export default CopyNotification;
